import React, { useState, useEffect } from "react";
import "./userdashboardheader.css";
import { Link, useNavigate } from "react-router-dom";
import { BiUser, BiChevronDown } from "react-icons/bi";
import { RiLuggageDepositLine } from "react-icons/ri";
import { AiOutlineSetting, AiOutlineStock } from "react-icons/ai";
import { RiLockPasswordLine } from "react-icons/ri";
import { FiLogOut } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { GiReceiveMoney } from "react-icons/gi";
import { RxDashboard } from "react-icons/rx";
import { FaUserFriends } from "react-icons/fa";
import axios from "axios";

const Userdashboardheader = ({ route }) => {
  const navigate = useNavigate();
  const [dropDown, setDropDown] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        const response = await axios.get(`${route}/auth/getData`, {
          headers: {
            "x-access-token": token
          }
        });

        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate, route]);

  const [bgColor, setBgColor] = useState(false);
  const changeOnScroll = () => {
    if (window.scrollY >= 50) {
      setBgColor(true);
    } else {
      setBgColor(false);
    }
  };
  window.addEventListener("scroll", changeOnScroll);

  if (loading) {
    return <div className="loading-header">Loading...</div>;
  }

  return (
    <>
      {dropDown && (
        <div className="drop-down">
          <div className="dropdown-tabs" onClick={() => setDropDown(false)}>
            <AiOutlineClose />
            <p>close</p>
          </div>
          <div className="dropdown-header">
            <span className="profile-pic-container">
              {userData?.profilePicture ? (
                <img src={userData.profilePicture} alt="Profile" />
              ) : (
                userData?.firstName?.charAt(0)
              )}
            </span>
            <span className="dropdown-user-details">
              <p className="dropdown-name">
                {userData?.firstName || "Guest"}
              </p>
              <p className="dropdown-email">
                {userData?.email || ""}
              </p>
            </span>
          </div>

          <div className="dropdown-deposit-container">
            <h3>total amount</h3>
            <h2>${userData?.balance?.toFixed(2) || "0.00"} USD</h2>
            <p>referral bonus ${userData?.referralBonus?.toFixed(2) || "0.00"} USD</p>
          </div>
          <div className="mobile-tabs">
            <div className="dropdown-tabs" onClick={() => navigate("/dashboard")}>
              <RxDashboard />
              <p>dashboard</p>
            </div>
            <div className="dropdown-tabs" onClick={() => navigate("/fundwallet")}>
              <GiReceiveMoney />
              <p>deposit</p>
            </div>
            <div className="dropdown-tabs" onClick={() => navigate("/plans")}>
              <AiOutlineStock />
              <p>select plan</p>
            </div>
            <div className="dropdown-tabs" onClick={() => navigate("/withdraw")}>
              <RiLuggageDepositLine />
              <p>withdraw</p>
            </div>
            <div className="dropdown-tabs" onClick={() => navigate("/referrals")}>
              <FaUserFriends />
              <p>referral</p>
            </div>
          </div>
          <div className="dropdown-tabs" onClick={() => navigate("/myprofile")}>
            <AiOutlineSetting />
            <p>profile setting</p>
          </div>
          <div className="dropdown-tabs" onClick={() => navigate("/myprofile")}>
            <RiLockPasswordLine />
            <p>change password</p>
          </div>
          <div className="dropdown-tabs" onClick={logout}>
            <FiLogOut />
            <p>logout</p>
          </div>
        </div>
      )}
      <div className={`userdashboard-header ${bgColor ? "scroll-head" : ""}`}>
        <div className="userdashboard-logo-container">
          <img
            src="/full-logo-black.png"
            alt="Logo"
            className="logo"
            onClick={() => navigate("/")}
          />
        </div>
        <nav className="user-header-nav">
          <ul>
            <li><Link to="/dashboard">dashboard</Link></li>
            <li><Link to="/fundwallet">Fund ledger</Link></li>
            <li><Link to="/plans">stake</Link></li>
            <li><Link to="/withdraw">withdrawals</Link></li>
            <li><Link to="/transactions">transactions</Link></li>
            <li><Link to="/referrals">referrals</Link></li>
            {userData?.promo && (
              <li><Link to="/viplan">vip plan</Link></li>
            )}
          </ul>
        </nav>
        <div className="header-profile-container" onClick={() => setDropDown(true)}>
          <span className="user-icon-wrapper">
            <BiUser />
          </span>
          <p>{userData?.firstName || "Guest"}</p>
          <span className="arrow-container">
            <BiChevronDown />
          </span>
        </div>
      </div>
    </>
  );
};

export default Userdashboardheader;
